import React from 'react';

export const BrandsSection: React.FC = () => {
  const brands = [
    {
      name: 'Blaze Harmony',
      description: 'Moderní topné systémy s vysokou účinností a spolehlivostí',
      image: 'https://public.readdy.ai/ai/img_res/cae1ac98-d89a-49d6-8bb7-3238ad29b14f.png',
      color: 'orange',
      bgGradient: 'from-orange-50 to-white',
      accentColor: 'text-orange-600',
      buttonBg: 'bg-orange-500 hover:bg-orange-600',
      website: 'www.blazeharmony.com',
      link: 'https://www.blazeharmony.com/'
    },
    {
      name: 'Atmos',
      description: 'Kvalitní kotle a topná zařízení pro domácnosti i průmysl',
      image: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/80b2a17f884d58d3d9cedd49ca27cef0.png',
      color: 'blue',
      bgGradient: 'from-blue-50 to-white',
      accentColor: 'text-blue-600',
      buttonBg: 'bg-blue-600 hover:bg-blue-700',
      website: 'www.atmos.eu',
      link: 'https://www.atmos.eu/'
    },
    {
      name: 'Opop',
      description: 'Špičková řešení pro vytápění a ohřev vody',
      image: 'https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/84251d2c791fcb145d651fab527ee5c9.png',
      color: 'orange',
      bgGradient: 'from-orange-50 to-white',
      accentColor: 'text-orange-600',
      buttonBg: 'bg-orange-500 hover:bg-orange-600',
      website: 'www.opop.cz',
      link: 'https://www.opop.cz/'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            <strong>Značky, které montujeme</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Pracujeme pouze s prověřenými a kvalitními značkami, které zaručují dlouhou životnost a spolehlivost
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {brands.map((brand, index) => (
            <div 
              key={index} 
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100 flex flex-col"
            >
              <a 
                href={brand.link}
                target="_blank"
                rel="noopener noreferrer"
                className="cursor-pointer"
              >
                <div className={`bg-gradient-to-br ${brand.bgGradient} p-8 flex items-center justify-center h-72`}>
                  <img 
                    src={brand.image} 
                    alt={brand.name}
                    title={brand.name}
                    className="w-full h-full object-contain"
                  />
                </div>
              </a>
              <div className="p-6 bg-white flex flex-col flex-grow">
                <h3 className={`text-2xl font-bold mb-3 ${brand.accentColor}`}>
                  {brand.name}
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed flex-grow min-h-[3rem]">
                  {brand.description}
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                  <span className="text-sm text-gray-500">
                    <i className="ri-global-line mr-1"></i>
                    {brand.website}
                  </span>
                  <a 
                    href={brand.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${brand.buttonBg} text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer inline-block`}
                  >
                    Více info
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
